<h2 class="text-center" mat-dialog-title>Envio de firmas</h2>
<mat-dialog-content class="row">
  <div *ngIf="dataToShow[0]" class="col-12 mb-4" >
    <h6 >Comprador: {{data.nombreCliente}} </h6>
      <section class="section">
        <mat-checkbox class="emargin" [(ngModel)]="docs.comprador.mandato" [checked]="docs.comprador.mandato">Mandato</mat-checkbox>
        <mat-checkbox class="emargin" [(ngModel)]="docs.comprador.poder" [checked]="docs.comprador.poder">Poder</mat-checkbox>
        <mat-checkbox class="emargin" [(ngModel)]="docs.comprador.compraventa" *ngIf="tipo.startsWith('CAMBIO DE') || tipo.startsWith('NOTIFICACION')" [checked]="docs.comprador.compraventa">Contrato de compraventa</mat-checkbox>
        <!--<mat-checkbox class="emargin" [(ngModel)]="docs.comprador.compraventa" *ngIf="tipo.startsWith('CAMBIO DE')" (change)="autocheck()" [checked]="docs.comprador.compraventa">Contrato de compraventa</mat-checkbox>-->
      </section>
    </div>

  <div *ngIf="dataToShow[1]" class="col-12 mb-4" >
    <h6 >Vendedor: {{data.nombreVendedor}} </h6>
    <section class="section">
      <mat-checkbox class="emargin"  [(ngModel)]="docs.vendedor.mandato" [checked]="docs.vendedor.mandato">Mandato</mat-checkbox>
      <mat-checkbox class="emargin"  [(ngModel)]="docs.vendedor.poder" [checked]="docs.vendedor.poder">Poder</mat-checkbox>
      <mat-checkbox class="emargin"  [(ngModel)]="docs.vendedor.compraventa" *ngIf="tipo.startsWith('CAMBIO DE') || tipo.startsWith('NOTIFICACION')" [checked]="docs.vendedor.compraventa">Contrato de compraventa</mat-checkbox>
      <!--<mat-checkbox class="emargin"  [(ngModel)]="docs.vendedor.compraventa" *ngIf="tipo.startsWith('CAMBIO DE')" [disabled]="checkDisabled()" [checked]="docs.vendedor.compraventa">Contrato de compraventa</mat-checkbox>-->
    </section>
  </div>
  <div *ngIf="data.nombrePoseedor !== ''" class="col-12" >
    <h6  matTooltip="Doble tranferencia">Poseedor: {{data.nombrePoseedor}} </h6>

  </div>


</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button  mat-dialog-close>Cancelar</button>
  <button mat-button   (click)="submit()" >Enviar</button>
</mat-dialog-actions>


<div *ngIf="spinnerFirma" class="spinner swal2-container swal2-center swal2-backdrop-show">
  <img class="spinner-img" alt="" src="../../../assets/img/logo-empresa.png">
  <h4  style="margin-top: 200px; color: white">Enviando datos para la firma de documentos...</h4>
</div>
